import { combineReducers } from '@reduxjs/toolkit';
import { createCustomSlice } from '../store.utils';
import { getProductsListByIdsAsyncThunk } from './products.action';

// ---------- GET LIST BY IDS ----------
const productsListByIdsSlice = createCustomSlice(
  'products/getListByIds',
  getProductsListByIdsAsyncThunk
);

export const { reset: resetProductsListByIds } = productsListByIdsSlice.actions;

// ---------- COMBINED REDUCER ----------
export const productsReducer = combineReducers({
  productsListByIds: productsListByIdsSlice.reducer,
});
